import type { ConfigSource } from '@/hooks/useGatewayConfigSources';

/** What a source offers, in a few words. */
export function sourceOffers(s: ConfigSource): string {
  if (s.router) {
    const parts = [`${s.router.preference} preference`];
    if (!s.router.default_router) parts.push('not a default router (lifetime 0)');
    if (s.router.managed) parts.push('M');
    if (s.router.other_config) parts.push('O');
    if (s.router.proxy) parts.push('says it is an ND proxy');
    if (s.router.prefixes.length) parts.push(s.router.prefixes.join(', '));
    return parts.join(' · ');
  }
  const parts = [];
  if (s.identity !== s.address) parts.push(`server ${s.identity}`);
  if (s.relay) parts.push(`via relay ${s.relay}`);
  if (s.relayLeg) parts.push('answering another link through a relay');
  return parts.join(' · ') || '—';
}
